// src/components/OperationNotificationsContainer.tsx
import React from 'react';
import OperationNotification from './OperationNotification';
import {useAppSelector} from "../../redux/hooks";
import {selectAllOperations} from "../../redux/api/operations/operationsSelectors";

const OperationNotificationsContainer: React.FC = () => {
    // Получаем все операции из Redux
    const operations = useAppSelector(selectAllOperations);

    return (
        <>
            {operations.map((op) => (
                <OperationNotification key={op.id} operation={op} />
            ))}
        </>
    );
};

export default OperationNotificationsContainer;
